import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import UnitExercisesPreviewSkeleton from './UnitExercisesPreviewSkeleton'

const placeholderItems = Array.from({ length: 4 }).map((_, index) => ({
  id: index,
}))

const UnitExercisesPreviewPlaceholder = () => (
  <UnitExercisesPreviewSkeleton
    titleSection={
      <LoadingBox width="200px" maxWidth="100%">
        &nbsp;
      </LoadingBox>
    }
    moreSection={null}
    items={placeholderItems}
    ItemComponent={(item) => <LoadingBox width="100%" height="176px" />}
  />
)

export default UnitExercisesPreviewPlaceholder
